export const encryptionKeys = {
  algo: 'aes-256-cbc',
  key: '7c2f3df62afa89ee9b27423858c1f452' || '',
  iv: process.env.PRIVATE_KEY || '',
};

export const jwtKeys = {
  staticUniqueKey: ['socialpilot703', 'socialpilot704'],
  secretKey: 'hagsdhjfghajdsgfkhjasdfgasdjkfgsa',
  jwtexpiresIn: '1d',
};
